// Customizable Area Start
import { IBlock } from "../../../framework/src/IBlock";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";
import { Message } from "../../../framework/src/Message";
import { getStorageData, setStorageData, removeStorageData } from "../../../framework/src/Utilities";
import * as yup from 'yup';
import { parsePhoneNumber } from 'libphonenumber-js';
import { loadStripe } from "@stripe/stripe-js";
import moment from "moment";
import { getToken } from "../../../components/src/AuthService";
import { MouseEvent } from "react";
import { baseURL } from "../../../framework/src/config";
// Import message variables system
import {
  MessageVariableProcessor,
  MessageVariableContext,
  DEFAULT_MESSAGE_VARIABLES
} from '../../utilities/src/MessageVariables';

export const configJSON = require("./config");

export const isValidPhoneNumber = (mobile_number: string): boolean => {
  try {
    // Assuming `parsePhoneNumber` is a function available in your code
    const parsedPhoneNumber = parsePhoneNumber(`+${mobile_number}`);

    return !!parsedPhoneNumber && parsedPhoneNumber.isValid();
  } catch (error) {
    return false;
  }
}

export const stripePromise = loadStripe(configJSON.stripeKey);

export interface MessageItem {
  id: string;
  text: string;
  timestamp: string;
  type: 'sent' | 'received';
  sender?: string;
}

export interface Props {
  navigation: any;
  location?: any
  id: string;
  contactId?: any;
  createId: number;
  classes: any;
  subscriptionListData?: any;
  waitlListFoldersName?: string;
  addFolderModalFunction?: any;

}

interface S {
  websites: any;
  activePopoverId: any;
  anchorEl: any;
  activeContactId: any;
  loading: boolean;
  createWebModal: boolean;
  websiteName: string;
  websiteUrl: string;
  websiteNameErr: string;
  websiteUrlErr: string;
  isShowAlert: boolean;
  alertMessage: string;
  endWaitlistModal: boolean;
  updateWebsiteId: string;
  openSubscripttionDialogue: boolean;
  addNotesField: boolean;
  setToken: string;
  folders: any;
  modalData: number;
  waitListContactsData: any;
  date: any;
  contactsInFoder: any;
  removeContactId: any;
  showSucess: string;
  errorAlertMessage: boolean;
  selectedContacts: any,
  normalizedContacts: any,
  checked: boolean,
  confirmModal: boolean
  addFolder: boolean,
  pricingRadioButton: boolean,
  automationTemplateData: any,
  customizableSubscriptionData: any

  folderName: string,
  openPaymentModal: boolean,
  clientSecretData: any,
  secretKey: any,
  bulkUploadContactsData: any,
  currentContactsModal: boolean,
  isCurrentContactSelected: boolean,
  currentContactListData: any,
  selectedCurrentContacts: any,
  selectedContactId: any,
  searchQuery: string,
  sendId: any,
  perticularContactDetail: any,
  actions: any,
  selectedContactName: string,
  // Message variables state
  messageProcessor: MessageVariableProcessor | null;
  messageVariableContext: MessageVariableContext;
  // Business contact information
  businessName: string;
  businessContactFirstName: string;
  businessContactLastName: string;
  businessPhoneNumber: string;
  businessEmail: string;
  // Waitlist chat message state
  messageText: string;
  savedMessageTemplate: string;
  messages: MessageItem[];
  selectedContactForChat: any;
  waitlistFolderId: string | number;
  isLike: boolean;
  isLoadingMessages: boolean
}
interface SS {
  id: any;
}
export default class WaitListController extends BlockComponent<Props, S, SS> {
  getwebsitesAPIID: any = "";
  createWebsiteAPIID: any = "";
  deleteWebsiteAPIID: any = "";
  updateWebsiteAPIID: any = "";
  getWaitListFoldersId: string = "";
  getWaitListContactsId: string = "";
  createWaitlistContactId: string = "";
  getContactsOfWaitlistFolderId: string = "";
  removeContactId: string = "";
  confirmAddContactToWaitListId: string = "";
  createAutomationTemplateId: string = "";
  getAutomationTemplateId: string = "";
  getCustomizableSubscriptionId: string = "";
  getCurrentBuPlanAPIID: string = "";
  getSubscriptionSecretKeyId: string = "";
  createWaitListFolderId: any = "";
  getdraftsContactsId: string = "";
  getCurrentContactListId: string = "";
  getPerticularContactId: string = "";
  removeBulkContactToWaitListId: string = "";
  sendWaitListMessageId: string = "";
  getWaitlistAutomationTemplateId: string = "";
  getWaitlistContactMessagesId: string = "";
  getWaitlistContactMessagesByContactIdId: string = "";
  chatSocket: WebSocket | null = null;
  chatSocketReconnectTimer: ReturnType<typeof setTimeout> | null = null;


  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);
    this.subScribedMessages = [getName(MessageEnum.RestAPIResponceMessage),
    getName(MessageEnum.SessionResponseMessage),
    getName(MessageEnum.ConnectTOSidebar),

    ];

    this.state = {
      websites: [],
      activePopoverId: null,
      anchorEl: null,
      activeContactId: null,
      loading: false,
      createWebModal: false,
      websiteName: "",
      websiteUrl: "",
      websiteNameErr: "",
      websiteUrlErr: "",
      isShowAlert: false,
      alertMessage: "",
      endWaitlistModal: false,
      updateWebsiteId: "",
      openSubscripttionDialogue: false,
      addNotesField: false,
      setToken: "",
      folders: [],
      modalData: 0,
      waitListContactsData: [],
      date: "",
      contactsInFoder: [],
      removeContactId: 0,
      showSucess: "",
      errorAlertMessage: false,
      selectedContacts: [],
      normalizedContacts: [],
      checked: false,
      confirmModal: false,
      addFolder: false,
      pricingRadioButton: false,
      automationTemplateData: [],
      customizableSubscriptionData: [],
      isLoadingMessages: true,
      folderName: "",
      openPaymentModal: false,
      clientSecretData: {},
      secretKey: null,
      bulkUploadContactsData: [],
      currentContactsModal: false,
      isCurrentContactSelected: false,
      currentContactListData: [],
      selectedCurrentContacts: -1,
      selectedContactId: null,
      searchQuery: "",
      sendId: null,
      perticularContactDetail: {},
      actions: null,
      selectedContactName: "",
      isLike: false,
      // Message variables state
      messageProcessor: null,
      messageVariableContext: {
        contact: undefined,
        business: {
          id: '',
          name: '',
          contact_first_name: '',
          contact_last_name: '',
          contact_full_name: '',
          office_number: '',
          email: ''
        },
        system: {
          current_user_id: '',
          current_business_id: '',
          timestamp: new Date().toISOString()
        }
      },
      // Business contact information
      businessName: '',
      businessContactFirstName: '',
      businessContactLastName: '',
      businessPhoneNumber: '',
      businessEmail: '',
      // Waitlist chat message state
      messageText: '',
      savedMessageTemplate: '',
      messages: [
        {
          id: '1',
          text: 'Hey',
          timestamp: '10:50 AM',
          type: 'received',
          sender: 'Michelle Jones'
        },
        {
          id: '2',
          text: 'Hey there! I was wondering if you have any recommendations for a good coffee shop in the area. I\'m in need of a caffeine fix!',
          timestamp: '10:50 AM',
          type: 'sent',
          sender: 'You'
        }
      ],
      selectedContactForChat: null,
      waitlistFolderId: '',
    };
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }


  isShowCell = () => {
    setTimeout(() => this.setState({ isShowAlert: false }), 3000);
  }


  closeModal = () => {
    this.setState({
      createWebModal: false,
      automationTemplateData: null
    });
  };

  currentContactSelected = (index: number, id: any) => {

    if (this.state.selectedCurrentContacts === index) {

      this.setState({ selectedCurrentContacts: -1, selectedContactId: null });
    } else {

      this.setState({ selectedCurrentContacts: index, selectedContactId: id });
    }
  };

  // pricingChangeFunction removed - only yearly plans available now
  openCurrentContactsModal = (id: any) => {

    this.addFolderModal()
    this.getCurrentContactsApi(id)
    this.setState({ currentContactsModal: !this.state.currentContactsModal });
  };

  componentDidUpdate(prevProps: any, prevState: any) {
    // Check if the modal has been reopened
    if (prevState.currentContactsModal !== this.state.currentContactsModal && this.state.currentContactsModal === true) {
      // Reset the selected contact state
      this.setState({ selectedCurrentContacts: -1, selectedContactId: null });
    }
    // When contacts load and no contact is selected yet, show first contact's data
    if (prevState.waitListContactsData !== this.state.waitListContactsData && this.state.waitListContactsData.length > 0) {
      const hasNoSelection = !this.state.selectedContactName || !this.state.selectedContactForChat;
      if (hasNoSelection) {
        const firstContact = this.state.waitListContactsData[0];
        const selectedContactName = `${firstContact.attributes.first_name} ${firstContact.attributes.last_name}`;
        this.setState(
          { selectedContactName, selectedContactForChat: firstContact, messages: [], isLoadingMessages: true },
          () => {
            const conversationId =
              firstContact?.attributes?.twilio_conversation_id ||
              firstContact?.attributes?.conversation_id;

            const contactId = firstContact?.id;
            console.log("contactId 12121", contactId);

            this.getWaitlistContactMessages(
              conversationId ? String(conversationId) : undefined,
              !conversationId && contactId ? String(contactId) : undefined
            );
          }
        );
      }
    }
  }



  openModal = async (id: any) => {



    this.setState({ createWebModal: true, sendId: id });


    this.getAutomationTemplate(id)
  };


  paymentModal = async () => {
    console.log("paymentModal called, current state:", this.state.openPaymentModal);
    console.log("subscriptionListData:", this.props.subscriptionListData);

    // Toggle payment modal - if closed, open it; if open, close it
    if (!this.state.openPaymentModal) {
      // Opening payment modal - fetch secret key
      this.setState({ openPaymentModal: true });

      // Try to fetch subscription data if not available, but don't block opening
      if (!this.props.subscriptionListData || !this.props.subscriptionListData[0]) {
        // Fetch subscription data in background
        console.log("Subscription data not available, fetching in background...");
        await this.getCustomizableSubscription();
        // Wait a bit for the data to be set, then fetch secret key
        setTimeout(() => {
          this.crateWaitlistSubscriptionSecretKey();
        }, 500);
      } else {
        console.log("Fetching secret key...");
        this.crateWaitlistSubscriptionSecretKey();
      }
    } else {
      // Closing payment modal - go back to subscription page
      this.setState({ openPaymentModal: false });
    }
  };

  handleClickOpen = async (id: any, name: string) => {
    console.log("id open modal show idid", name);

    id && await this.getWaitListContactsList(id);
    this.setState({ openSubscripttionDialogue: !this.state.openSubscripttionDialogue, modalData: id, folderName: name })

  };


  sendInfoToMainLayout = (data: any) => {
    const msg = new Message(getName(MessageEnum.ConnectTOSidebar))
    msg.addData(getName(MessageEnum.ShouldUpdate), data)
    this.send(msg)
  }


  addFolderModal = async () => {
    this.getCustomizableSubscription()
    // Reset payment modal state when opening/closing folder modal
    // This ensures subscription page shows first, not payment page
    this.setState({
      addFolder: !this.state.addFolder,
      openPaymentModal: false // Always reset to show subscription page first
    })

  };
  handleClick = (event: any, contactId?: any) => {
    this.setState({ anchorEl: event.currentTarget, activeContactId: contactId });
  };

  handleClose = () => {
    this.setState({ anchorEl: null, activeContactId: null });
  };

  handleFilledOpenSpot = () => {
    // TODO: Implement filled open spot functionality
    console.log("Filled open spot for contact:", this.state.activeContactId);
    this.setState({ anchorEl: null, activeContactId: null });
  };

  handlePassedOnSpot = () => {
    // TODO: Implement passed on spot functionality
    console.log("Passed on spot for contact:", this.state.activeContactId);
    this.setState({ anchorEl: null, activeContactId: null });
  };

  handleRemoveContact = () => {
    // Capture id before closing popover – Popover onClose can clear activeContactId before this runs
    const contactIdToRemove = this.state.activeContactId;
    this.setState({ anchorEl: null, activeContactId: null });
    if (contactIdToRemove) {
      this.openConfirmModal(contactIdToRemove);
    }
  };

  openaddNotesField = () => {
    this.setState({ addNotesField: !this.state.addNotesField });
  };

  openConfirmModal = (id: any) => {
    this.setState({ confirmModal: true, removeContactId: id });
  };
  closeConfirmModal = () => {

    this.setState({ confirmModal: false });
  };
  openEndWaitListModal = () => {

    this.setState({ endWaitlistModal: true });
  };
  closeEndWaitListModal = () => {

    this.setState({ endWaitlistModal: false });
  };
  onDateChange = (date: any, setFieldValue: any) => {
    this.setState({ date: date })
    setFieldValue('appointment_date', date)

  };

  async receive(from: string, message: Message) {
    const messageType = getName(MessageEnum.RestAPIResponceMessage);
    if (message.id == getName(MessageEnum.ConnectTOSidebar)) {
      let data = message.getData(getName(MessageEnum.ShouldUpdate))
      if (data && data.refresh) {
        this.getWaitListContactsList(this.state.modalData)
        this.getWaitListFolders()
        this.getDraftsContactsinWaitList()
      }
    }
    if (messageType === message.id) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );
      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      switch (apiRequestCallId) {

        case this.getWaitListFoldersId:
          if (responseJson.data) {
            this.setState({ folders: responseJson.data })
            // this.getAutomationTemplate(responseJson.data[0]?.attributes?.automation?.id)
            const plainTextTemplate = this.stripHtmlTags(responseJson.data[0]?.attributes?.automation?.message_template);

            this.setState({
              savedMessageTemplate: responseJson.data[0]?.attributes?.automation?.message_template, // Keep original with HTML
              messageText: plainTextTemplate // Use plain text for input
            });
          }
          break;

        case this.getWaitListContactsId:
          this.getWaitlistContactResponse(responseJson)
          break;


        case this.createWaitlistContactId:
          if (responseJson.error) {

            this.setState({ isShowAlert: true, showSucess: responseJson.error[0], errorAlertMessage: true }, () => {
              this.isShowCell()
            })
          }
          else {
            this.state.actions.resetForm()
            this.setState({ modalData: responseJson.data.attributes.waitlist_id }, async () => {

              // Send refresh message without causing page reload
              setTimeout(() => {
                this.sendInfoToMainLayout({ refresh: true })
              }, 100);

              this.setState({ isShowAlert: true, showSucess: "Contact Created Successfully", errorAlertMessage: false, perticularContactDetail: {}, date: "" }, () => {
                this.isShowCell()
                this.getDraftsContactsinWaitList()
              })

            })
          }
          break;


        case this.confirmAddContactToWaitListId:
          this.conirmContactToWaitlistResponse(responseJson)
          break;

        case this.getAutomationTemplateId:
          this.getAutmationTemplateResponse(responseJson)
          // Store message template for chat - strip HTML tags for input field
          if (responseJson.data?.attributes?.message_template) {
            const plainTextTemplate = this.stripHtmlTags(responseJson.data.attributes.message_template);
            this.setState({
              savedMessageTemplate: responseJson.data.attributes.message_template, // Keep original with HTML
              messageText: plainTextTemplate // Use plain text for input
            });
          }
          break;

        case this.createAutomationTemplateId:
          this.createAutomationTemplateResponse(responseJson)
          break;

        case this.getCustomizableSubscriptionId:
          this.getCustomizableSubscriptionListResponse(responseJson)
          break;

        case this.getSubscriptionSecretKeyId:
          this.getClientSecretKeyResponse(responseJson)
          break;

        case this.getdraftsContactsId:
          this.getBulkUploadContactsResponse(responseJson)
          break;

        case this.removeContactId:
          this.getRemoveContactFromWaitlistResponse(responseJson)
          break;

        case this.getCurrentContactListId:
          this.getCurrentContactResponse(responseJson)
          break;

        case this.getPerticularContactId:
          this.getPerticularContactRespone(responseJson)
          break;

        case this.removeBulkContactToWaitListId:
          this.removeBulkContactToWaitlistResponse(responseJson)
          break;

        case this.sendWaitListMessageId:
          console.log("responseJson sendWaitListMessageId", responseJson);
          if (responseJson.error) {
            this.setState(
              {
                isShowAlert: true,
                errorAlertMessage: true,
                showSucess: responseJson.error[0] || "Failed to send message",
              },
              () => {
                this.isShowCell();
              }
            );
          } else {
            // Add sent message to messages array
            const newMessage: MessageItem = {
              id: Date.now().toString(),
              text: this.state.messageText,
              timestamp: new Date().toLocaleTimeString(),
              type: "sent",
              sender: this.state.businessContactFirstName || "You",
            };

            const selectedContactForChat = this.state.selectedContactForChat;
            const conversationId =
              selectedContactForChat?.attributes?.conversation_id ||
              selectedContactForChat?.attributes?.twilio_conversation_id;

            this.setState(
              (prevState) => ({
                messages: [...prevState.messages, newMessage],
                isShowAlert: true,
                errorAlertMessage: false,
                showSucess: "Message sent successfully",
                messageText: "", // Reset to template
              }),
              () => {
                this.isShowCell();
                // After sending, refresh the full message thread from the server
                if (conversationId) {
                  this.getWaitlistContactMessages(String(conversationId));
                }
              }
            );
          }
          break;

        case this.getWaitlistContactMessagesId:
          if (responseJson?.error) {
            this.setState({ messages: [] });
          } else {
            // API can return: { sender: [...] }, { receiver: [...] }, { data: [...] }, or { data: { messages: [...] } }
            const senderList = Array.isArray(responseJson?.sender) ? responseJson.sender : [];
            const receiverList = Array.isArray(responseJson?.receiver) ? responseJson.receiver : [];
            const otherList = Array.isArray(responseJson?.data)
              ? responseJson.data
              : Array.isArray(responseJson?.data?.messages)
                ? responseJson.data.messages
                : Array.isArray(responseJson?.data?.data)
                  ? responseJson.data.data
                  : Array.isArray(responseJson?.messages)
                    ? responseJson.messages
                    : [];

            const withType = (list: any[], type: 'sent' | 'received') =>
              list.map((item: any, index: number) => {
                const attrs = item?.attributes ?? item;
                const text = attrs?.body ?? attrs?.text ?? attrs?.message ?? '';
                const ts = attrs?.created_at ?? attrs?.timestamp ?? attrs?.date;
                const timestamp = ts
                  ? (moment(ts).isValid() ? moment(ts).format('h:mm A') : String(ts))
                  : '';
                return {
                  id: String(item?.id ?? `${type}-${index}`),
                  text,
                  timestamp: timestamp || new Date().toLocaleTimeString(),
                  type,
                  sender: type === 'received' ? (this.state.selectedContactName || 'Contact') : 'You',
                  _sortAt: ts ? (moment(ts).isValid() ? moment(ts).valueOf() : 0) : 0
                };
              });

            const sentItems = withType(senderList, 'sent');
            const receivedItems = withType(receiverList, 'received');
            const otherItems = otherList.map((item: any, index: number) => {
              const attrs = item?.attributes ?? item;
              const text = attrs?.body ?? attrs?.text ?? attrs?.message ?? '';
              const senderType = (attrs?.sender_type ?? attrs?.direction ?? attrs?.type ?? '').toString().toLowerCase();
              const type: 'sent' | 'received' =
                senderType === 'contact' || senderType === 'inbound' || senderType === 'received' ? 'received' : 'sent';
              const ts = attrs?.created_at ?? attrs?.timestamp ?? attrs?.date;
              const timestamp = ts
                ? (moment(ts).isValid() ? moment(ts).format('h:mm A') : String(ts))
                : '';
              return {
                id: String(item?.id ?? index),
                text,
                timestamp: timestamp || new Date().toLocaleTimeString(),
                type,
                sender: type === 'received' ? (this.state.selectedContactName || 'Contact') : 'You',
                _sortAt: ts ? (moment(ts).isValid() ? moment(ts).valueOf() : 0) : 0
              };
            });

            const combined: any[] = [...sentItems, ...receivedItems, ...otherItems].sort(
              (a, b) => (a._sortAt ?? 0) - (b._sortAt ?? 0)
            );
            const messages: MessageItem[] = combined.map(({ _sortAt, ...msg }) => msg);
            this.setState({ messages, isLoadingMessages: false });
          }
          break;

      }








    }
  }

  getSelectedConversationId = () => {
    const selected = this.state.selectedContactForChat;
    return (
      selected?.attributes?.conversation_id ||
      selected?.attributes?.twilio_conversation_id ||
      selected?.conversation_id ||
      selected?.twilio_conversation_id ||
      ""
    );
  };

  initializeChatSocket = () => {
    const token =
      this.state.setToken ||
      sessionStorage.getItem("userToken") ||
      localStorage.getItem("authToken");
    if (!token) return;

    const wsBase = baseURL.replace(/^http/i, "ws");
    this.chatSocket = new WebSocket(`${wsBase}/cable?token=${token}`);
    this.chatSocket.onopen = this.handleChatSocketOpen;
    this.chatSocket.onmessage = this.handleChatSocketMessage;
    this.chatSocket.onclose = this.handleChatSocketClose;
    this.chatSocket.onerror = this.handleChatSocketClose;
  };

  handleChatSocketOpen = () => {
    if (!this.chatSocket || this.chatSocket.readyState !== WebSocket.OPEN) return;
    this.chatSocket.send(
      JSON.stringify({
        command: "subscribe",
        identifier: JSON.stringify({ channel: "ChatMessagesChannel" }),
      })
    );
  };

  handleChatSocketMessage = (event: MessageEvent) => {
    try {
      const payload = JSON.parse(event.data);
      if (!payload.message || typeof payload.message !== "object") return;

      const data = payload.message;
      const eventType = data.type;
      if (eventType !== "new_message" && eventType !== "delivery_status") return;

      const incomingConversationId = String(data.conversation_id || "");
      const selectedConversationId = String(this.getSelectedConversationId() || "");

      if (incomingConversationId && selectedConversationId && incomingConversationId === selectedConversationId) {
        const selectedContact = this.state.selectedContactForChat;
        const contactId = selectedContact?.id;
        this.getWaitlistContactMessages(incomingConversationId, contactId ? String(contactId) : undefined);
      }

      if (this.state.modalData) {
        this.getWaitListContactsList(this.state.modalData);
      }
    } catch (error) {
      console.error("Failed to parse waitlist chat realtime message", error);
    }
  };

  handleChatSocketClose = () => {
    if (this.chatSocketReconnectTimer) clearTimeout(this.chatSocketReconnectTimer);
    this.chatSocketReconnectTimer = setTimeout(() => {
      this.initializeChatSocket();
    }, 3000);
  };

  teardownChatSocket = () => {
    if (this.chatSocketReconnectTimer) {
      clearTimeout(this.chatSocketReconnectTimer);
      this.chatSocketReconnectTimer = null;
    }
    if (this.chatSocket) {
      this.chatSocket.onopen = null;
      this.chatSocket.onmessage = null;
      this.chatSocket.onclose = null;
      this.chatSocket.onerror = null;
      this.chatSocket.close();
      this.chatSocket = null;
    }
  };

  handleSubmit = async (
    event: MouseEvent<HTMLButtonElement>,
    stripe: any,
    elements: any
  ) => {
    event.preventDefault(); // Prevent default form behavior

    if (!stripe || !elements) {
      console.error("Stripe or Elements not loaded.");
      return;
    }

    // Get token from sessionStorage or state (same as sign-up page)
    const token = sessionStorage.getItem("userToken") || localStorage.getItem("authToken") || this.state.setToken;
    if (!token) {
      console.error("No token found in sessionStorage, localStorage, or state.");
      this.setState({
        isShowAlert: true,
        showSucess: "Authentication error. Please try again.",
        errorAlertMessage: true
      }, () => {
        this.isShowCell();
      });
      return;
    }

    // ✅ 1. Store token in localStorage BEFORE payment confirmation (same as sign-up)
    await setStorageData("authToken", token);
    localStorage.setItem("authToken", token);

    // Submit the form first to validate
    const submitResult = await elements.submit();

    if (submitResult.error) {
      console.error("Form validation error:", submitResult.error.message);
      this.setState({
        isShowAlert: true,
        showSucess: submitResult.error.message || "Please check your payment information",
        errorAlertMessage: true
      }, () => {
        this.isShowCell();
      });
      return;
    }

    const matchResult = window.location.href.match(/^(https?:\/\/[a-z0-9\:\-.]+)\//);
    const dynamicBaseUrl = matchResult ? matchResult[1] : '';
    const returnUrl = `${dynamicBaseUrl}/waitList`;

    try {
      // ✅ 2. Confirm payment with Stripe (same pattern as sign-up page)
      const result = await stripe.confirmPayment({
        elements,
        clientSecret: this.state.secretKey,
        confirmParams: {
          return_url: returnUrl
        },
        redirect: "if_required" // Only redirect if 3D Secure is needed (same as sign-up)
      });

      if (result.error) {
        console.error("Stripe payment error:", result.error.message);
        // Remove token on error (same as sign-up)
        await removeStorageData("authToken");
        localStorage.removeItem("authToken");
        this.setState({
          isShowAlert: true,
          showSucess: result.error.message || "Payment failed. Please try again.",
          errorAlertMessage: true
        }, () => {
          this.isShowCell();
        });
      } else {
        console.log("✅ Payment successful!", result);

        // ✅ 3. Ensure token is set again before proceeding (same as sign-up)
        await setStorageData("authToken", token);
        localStorage.setItem("authToken", token);
        console.log("✅ Token confirmed in localStorage");

        // Payment successful - create folder and close modals
        this.setState({
          isShowAlert: true,
          showSucess: "Waitlist Subscription Is Done Successfully",
          errorAlertMessage: false
        }, () => {
          this.isShowCell();
          // Close payment modal
          this.paymentModal();
          // Close folder modal
          this.props.addFolderModalFunction();
          // Create the waitlist folder
          this.createWaitListFolderApi();
        });
      }
    } catch (error) {
      console.error("Error confirming payment:", error);
      // Remove token on error (same as sign-up)
      await removeStorageData("authToken");
      localStorage.removeItem("authToken");
      this.setState({
        isShowAlert: true,
        showSucess: "An error occurred. Please try again.",
        errorAlertMessage: true
      }, () => {
        this.isShowCell();
      });
    }
  };

  getCurrentContactResponse = (responseJson: any) => {
    if (responseJson.data) {
      const processedData = this.ensureAutomationDataStructure(responseJson.data);
      this.setState({ currentContactListData: processedData })
    }
  }
  getRemoveContactFromWaitlistResponse = (responseJson: any) => {
    if (responseJson.success) {
      this.sendInfoToMainLayout({ refresh: true })
      this.setState({ isShowAlert: true, showSucess: "Contact Is Removed Successfully" }, () => {
        this.isShowCell()
      })
    }
  }

  getPerticularContactRespone = (responseJson: any) => {

    if (responseJson.data) {
      this.setState({ perticularContactDetail: responseJson.data })

    }
  }


  getClientSecretKeyResponse = (responseJson: any) => {

    if (responseJson.data) {
      this.setState({ clientSecretData: responseJson.data, secretKey: responseJson.data.attributes.client_secret })

    }
  }


  getCustomizableSubscriptionListResponse = (responseJson: any) => {
    if (responseJson.data) {
      this.setState({ customizableSubscriptionData: responseJson.data })
    }

  }


  getBulkUploadContactsResponse = (responseJson: any) => {
    if (responseJson.data) {
      const processedData = this.ensureAutomationDataStructure(responseJson.data);
      this.setState({ bulkUploadContactsData: processedData })
    }
  }

  getAutmationTemplateResponse = (responseJson: any) => {

    if (responseJson) {
      this.setState({ automationTemplateData: responseJson.data })
    }
  }
  getWaitlistContactResponse = (responseJson: any) => {
    if (responseJson.data) {
      const processedData = this.ensureAutomationDataStructure(responseJson.data);
      const updates: any = { waitListContactsData: processedData };
      if (Array.isArray(processedData) && processedData.length > 0) {
        const first = processedData[0];
        if (first?.attributes) {
          updates.selectedContactName = `${first.attributes.first_name || ''} ${first.attributes.last_name || ''}`.trim();
          updates.selectedContactForChat = first;
          // When no contact is clicked yet, show first contact's data: reset messages and load them
          updates.messages = [];
          updates.isLoadingMessages = true;
        }
      }
      this.setState(updates, () => {
        // Load first contact's messages so chat shows first contact when user hasn't clicked anyone
        const first = Array.isArray(processedData) && processedData.length > 0 ? processedData[0] : null;
        if (first) {
          const conversationId =
            first.attributes?.twilio_conversation_id ||
            first.attributes?.conversation_id;
        
          const contactId = first.id;
        
          console.log("first", first);
        
          this.getWaitlistContactMessages(
            conversationId ? String(conversationId) : undefined,
            !conversationId && contactId ? String(contactId) : undefined
          );
        }
        
      });
    }
  }
  conirmContactToWaitlistResponse = (responseJson: any) => {
    if (responseJson) {

      this.sendInfoToMainLayout({ refresh: true })

      this.setState({ isShowAlert: true, showSucess: responseJson.message }, () => {
        this.isShowCell()
      })
    }
  }


  removeBulkContactToWaitlistResponse = (responseJson: any) => {
    if (responseJson) {

      this.sendInfoToMainLayout({ refresh: true })

      this.setState({ isShowAlert: true, showSucess: responseJson.message, selectedContacts: [] }, () => {
        this.isShowCell()
      })
    }
  }





  createAutomationTemplateResponse = (responseJson: any) => {
    if (responseJson.message === "automation not updated") {
      this.setState({ isShowAlert: true, errorAlertMessage: true, showSucess: responseJson.message }, () => {
        this.isShowCell()

      });
    } else {
      this.setState({
        isShowAlert: true,
        errorAlertMessage: false,
        showSucess: responseJson.message,
        automationTemplateData: null
      }, () => {
        this.isShowCell()
        this.closeModal()
        // Refresh the folders list to show updated name
        this.getWaitListFolders()
      });
    }
  }



  async componentDidMount(): Promise<void> {

    let token = await getToken();
    this.setState({ setToken: token }, () => {
      this.getWaitListFolders()
      this.initializeChatSocket();

      this.getCurrentBuPlan();
      this.getDraftsContactsinWaitList();
      const id = this.props.navigation.getParam('id') || this.props.createId
      console.log("Navigation ID:", this.props.navigation.getParam('id'));
      console.log("CreateId prop:", this.props.createId);
      console.log("Final ID being used:", id);

      this.getWaitListContactsList(id)
        .then(waitListContactsData => {
          // Check if waitListContactsData is an array and contains elements
          if (Array.isArray(waitListContactsData) && waitListContactsData.length > 0) {
            // Access the first element of the array and its attributes property
            const firstContact = waitListContactsData[0];
            // Ensure that the object has the attributes property
            if (firstContact && typeof firstContact === 'object' && firstContact.attributes) {
              // Now you can safely access the attributes property
              const selectedContactName = `${firstContact.attributes.first_name} ${firstContact.attributes.last_name}`;
              this.setState({ waitListContactsData, selectedContactName });
            }
          }
        })
        .catch(error => {
          // Handle error if any
          console.error("Error fetching waitlist contacts data:", error);
        });
      this.getWaitListFolders()





    });


  }

  async componentWillUnmount(): Promise<void> {
    this.teardownChatSocket();
  }



  validationSchema = yup.object().shape({
    first_name: yup.string().required(configJSON.firstNameErrorMessage),
    last_name: yup.string().required(configJSON.lastNameErrorMessage),
    full_phone_number: yup.string().required(configJSON.phoneNumberErrorMessage).
      test('phoneno', "Enter a valid phone number", function (value: any) {
        return value && isValidPhoneNumber(value);
      }),
    appointment_date: yup.date().required('Date is requied'),
    appointment_time: yup.string().required('Time is required')


  });


  handleCheckboxChange = (contactId: any) => {

    const { selectedContacts } = this.state;

    // Toggle the selected state
    if (selectedContacts.includes(contactId)) {
      this.setState({
        selectedContacts: selectedContacts.filter((id: any) => id != contactId),
      });
    } else {
      this.setState({
        selectedContacts: [...selectedContacts, contactId],
      });
    }
  };




  handleConfirmRemoval = () => {



    this.removeconfirmContactsOfWaitlistApi(this.state.removeContactId)
    this.getDraftsContactsinWaitList()
    // Close the modal
    this.closeConfirmModal();
  };


  handleDoneButtonClick = async () => {

    const contactIds = this.state.bulkUploadContactsData.map((item: any) => item.id);

    const requestBody = {

      contact_ids: contactIds,
    };

    this.confirmContactsOfWaitlistApi(requestBody)

  };


  chatMemberChange = (selectedContactName: string, contact?: any) => {
    const plainTextTemplate = this.stripHtmlTags(this.state.savedMessageTemplate);
    this.setState(
      {
        selectedContactName,
        selectedContactForChat: contact || null,
        messageText: plainTextTemplate || '',
        messages: [], // Reset until API returns; will be set when getWaitlistContactMessages response arrives
        isLoadingMessages: true,
      },
      () => {
        // Load automation template if contact is selected
        if (contact && this.state.waitlistFolderId) {
          this.loadAutomationTemplateForFolder(this.state.waitlistFolderId);
        }
        // Call API to fetch messages for this contact (uses twilio_conversation_id or conversation_id)
        console.log("contactcontact", contact?.id);

        // const conversationId =
        //   contact?.attributes?.twilio_conversation_id ||
        //   contact?.attributes?.conversation_id ||
        //   contact?.attributes?.chat_conversation_id ||
        //   contact?.id
        const conversationId =
        contact?.attributes?.twilio_conversation_id ||
        contact?.attributes?.conversation_id;

      const contactId = contact?.id;
      console.log("contactId 12121", contactId);

      this.getWaitlistContactMessages(
        conversationId ? String(conversationId) : undefined,
        !conversationId && contactId ? String(contactId) : undefined
      );
        // if (conversationId) {
        //   this.getWaitlistContactMessages(String(conversationId));
        // }
      }
    );
  };

  // Load automation template for the waitlist folder
  loadAutomationTemplateForFolder = async (folderId: string | number) => {
    // Get the folder to find automation ID
    const folder = this.state.folders.find((f: any) => f.id === folderId || f.id === String(folderId));
    if (folder && folder.attributes?.automation?.id) {
      await this.getAutomationTemplate(folder.attributes.automation.id);
    }
  };

  // Helper to strip HTML tags from message template
  stripHtmlTags = (html: string): string => {
    if (!html) return '';
    const tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  };

  // Handle message input change
  handleMessageInputChange = (value: string) => {
    this.setState({ messageText: value });
  };

  // Send waitlist message - calls account_block/messages/send_chat_message API
  sendWaitListMessage = async () => {
    console.log("sendWaitListMessage called");

    const { messageText, selectedContactForChat } = this.state;

    if (!messageText || !selectedContactForChat) {
      console.warn("Missing message or contact");
      return;
    }

    const conversationId =
      selectedContactForChat.attributes?.conversation_id ||
      selectedContactForChat.attributes?.twilio_conversation_id;

    if (!conversationId) {
      console.error("Conversation ID missing");
      return;
    }

    const token =
      sessionStorage.getItem("userToken") ||
      localStorage.getItem("authToken");

    const requestBody = {
      tag: "waitlist",
      message: {
        conversation_id: String(conversationId),
        body: messageText,
      },
    };

    try {
      console.log("Calling send_chat_message API", requestBody);

      this.sendWaitListMessageId = await this.apiFrame({
        contentType: "application/json",
        method: "POST",
        endPoint: "account_block/messages/send_chat_message",
        body: requestBody,
        headers: { token },
      });

      // ✅ CLEAR AFTER SUCCESS
      this.setState({
        messageText: "",
        savedMessageTemplate: "",
      });

      console.log("Message sent & editor cleared");
    } catch (error) {
      console.error("Failed to send message", error);
    }
  };


  async apiFrame(data: any) {
    console.log("data apiFrame", data);
    const { contentType, method, endPoint, body, type, token: tokenOverride } = data
    const apiHeader = {
      "Content-Type": contentType,
      token: tokenOverride ?? this.state.setToken,
    }
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    )
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      endPoint
    )
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(apiHeader)
    )
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      method
    )
    body && type != "formData" ?
      requestMessage.addData(
        getName(MessageEnum.RestAPIRequestBodyMessage),
        JSON.stringify(body)
      )

      : requestMessage.addData(
        getName(MessageEnum.RestAPIRequestBodyMessage),
        body
      );
    runEngine.sendMessage(requestMessage.id, requestMessage);
    return requestMessage.messageId;
  }

  getWaitListFolders = async () => {
    this.getWaitListFoldersId = await this.apiFrame({
      contentType: configJSON.contentType,
      method: configJSON.getApiMethod,
      endPoint: configJSON.getWaitListFoldersEndPoint1
    });
  };




  getWaitListContactsList = async (id: number) => {
    console.log("id checking show idid", id);

    this.setState({ modalData: id })
    this.getWaitListContactsId = await this.apiFrame({
      contentType: configJSON.contentType,
      method: configJSON.getApiMethod,
      endPoint: configJSON.getWaitListFoldersEndPoint2 + `/${id}/contacts`
    });
    return this.getWaitListContactsId
  };

  createContactApi = async (values: any, id: number, actions: any) => {
    let requestBody = {
      contact: {
        first_name: values.first_name,
        last_name: values.last_name,
        full_phone_number: `+${values.full_phone_number}`,
        appointment_date: moment(values.appointment_date).format("MM-DD-YYYY"),
        appointment_time: values.appointment_time,
        note: values.note,
        is_draft_contact: true
      },
    };

    this.setState({ actions: actions })

    this.createWaitlistContactId = await this.apiFrame({
      contentType: configJSON.contentType,
      method: configJSON.postApiMethod,
      endPoint: configJSON.getWaitListFoldersEndPoint3 + `/${id}/contacts`,
      body: requestBody
    });

  };


  confirmContactsOfWaitlistApi = async (values: any) => {

    this.confirmAddContactToWaitListId = await this.apiFrame({
      contentType: configJSON.contentType,
      method: configJSON.postApiMethod,
      endPoint: configJSON.addBulkContactsInWaitList,
      body: values
    });

  };


  removeBulkContactsOfWaitlistApi = async () => {
    const reqBody = {
      "waitlist_id": this.props.createId,
      "contact_ids": this.state.selectedContacts
    }

    this.removeBulkContactToWaitListId = await this.apiFrame({
      contentType: configJSON.contentType,
      method: configJSON.postApiMethod,
      endPoint: configJSON.removeBulkContactsInWaitLIst,
      body: reqBody
    });

  };


  removeconfirmContactsOfWaitlistApi = async (id: any) => {

    this.removeContactId = await this.apiFrame({
      contentType: configJSON.contentType,
      method: configJSON.postApiMethod,
      endPoint: configJSON.removeWaitListContactEndPoint + `/${id}`,

    });

  };

  // Fetch messages for a waitlist contact (when user clicks a contact) - uses twilio_conversation_id or conversation_id
  getWaitlistContactMessages = async (
    conversationId?: string,
    contactId?: string
  ) => {
    if (!conversationId && !contactId) return;
    console.log("conversationId", conversationId);
    console.log("conversationId contactId", contactId);



    const token =
      this.state.setToken ||
      sessionStorage.getItem("userToken") ||
      localStorage.getItem("authToken");

    // ✅ decide query param dynamically
    const queryParam = conversationId
      ? `conversation_id=${encodeURIComponent(conversationId)}`
      : `contact_id=${encodeURIComponent(contactId!)}`;

    console.log("Fetching messages with", queryParam);

    this.getWaitlistContactMessagesId = await this.apiFrame({
      contentType: configJSON.contentType,
      method: configJSON.getApiMethod,
      endPoint: `account_block/messages/waitlist_contact_get_message?${queryParam}`,
      token,
    });
  };





  createAutomationTemplateApi = async (values: any) => {

    const requestBody = {
      attributes: {

        name: values.name,
        business_name: values.business_name,
        reminder_note: values.reminder_note,
        message_template: values.message_template
      },
    };
    this.createAutomationTemplateId = await this.apiFrame({
      contentType: configJSON.contentType,
      method: configJSON.putApiMethod,
      endPoint: configJSON.setUpAutomationEndPoint + `/${this.state.sendId}/update_waitlist_automation`,
      body: requestBody
    });

  };
  getAutomationTemplate = async (id: number) => {
    this.getAutomationTemplateId = await this.apiFrame({
      contentType: configJSON.contentType,
      method: configJSON.getApiMethod,
      endPoint: configJSON.getAutomationTemplateEndPoint + `/${id}`
    });
  };

  getCustomizableSubscription = async () => {
    this.getCustomizableSubscriptionId = await this.apiFrame({
      contentType: configJSON.contentType,
      method: configJSON.getApiMethod,
      endPoint: `${configJSON.getCustomizableSubscriptionEndPoint}?name=Waitlist`
    });
  };

  getCurrentBuPlan = async () => {
    this.getCurrentBuPlanAPIID = await this.apiFrame({
      contentType: configJSON.contentType,
      method: configJSON.getApiMethod,
      endPoint: configJSON.getCurrentBuPlanEndPoint
    });
  };





  crateWaitlistSubscriptionSecretKey() {
    // Use subscription data from props or state
    const subscriptionData = this.props.subscriptionListData?.[0] || this.state.customizableSubscriptionData?.[0];

    // Static/default price data for waitlist subscription
    const staticWaitlistPlan = {
      stripe_price_id: "price_default_waitlist", // Default or use actual price ID if available
      plan_id: 0, // Default plan ID
      productId: 0,
      subscription_id: null,
    };

    let selectedPlan;
    let plan;

    if (subscriptionData && subscriptionData.attributes?.plans && subscriptionData.attributes.plans.length > 0) {
      // Use actual subscription data if available
      const selectedPlanIndex = 0; // Always use yearly plan (index 0)
      plan = subscriptionData.attributes.plans[selectedPlanIndex];

      selectedPlan = {
        stripe_price_id: plan.stripe_plan_id,
        plan_id: plan.id,
        productId: subscriptionData.attributes.id || subscriptionData.id,
        subscription_id: subscriptionData.id || subscriptionData.attributes.id,
      };
    } else {
      // Use static/default data
      console.log("Using static price data for waitlist subscription");
      selectedPlan = staticWaitlistPlan;
    }

    // Get subscription_id (similar to sign-up flow)
    const subscriptionId = this.state.clientSecretData?.id
      || this.state.clientSecretData?.attributes?.id
      || this.state.clientSecretData?.data?.id
      || selectedPlan.subscription_id
      || selectedPlan.productId;

    // Use the same attrs structure as sign-up flow
    const attrs = {
      stripe_price_id: selectedPlan.stripe_price_id,
      plan_id: selectedPlan.plan_id,
      platform_management: false, // Waitlist doesn't use platform management
      subscription_id: subscriptionId || selectedPlan.productId,
      premium_waitlist: true, // Add waitlist flag
    };

    const httpBody = {
      subscription: attrs,
    };

    const headerData = {
      "Content-Type": configJSON.contentType,
      Token: getToken(),
    };


    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.getSubscriptionSecretKeyId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "POST"
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(httpBody)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getSecretKeyForSubscription
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headerData)
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
    return requestMessage.messageId;
  }


  createWaitListFolderApi = async () => {
    // Get the current number of folders to determine the next folder number
    const folderCount = this.state.folders.length;
    const nextFolderNumber = folderCount + 1;
    const folderName = `Folder ${nextFolderNumber}`;

    const requestBody = {
      "waitlist": {
        "name": folderName
      }
    }
    this.createWaitListFolderId = await this.apiFrame({
      contentType: configJSON.contentType,
      method: configJSON.postApiMethod,
      endPoint: configJSON.getWaitListFoldersEndPoint4,
      body: requestBody
    });
    // Refresh folders list immediately so new folder appears like existing cards
    setTimeout(() => {
      this.getWaitListFolders();
      this.sendInfoToMainLayout({ refresh: true })
    }, 500);
  };




  getDraftsContactsinWaitList = async () => {
    this.getdraftsContactsId = await this.apiFrame({
      contentType: configJSON.contentType,
      method: configJSON.getApiMethod,
      endPoint: configJSON.addBulkContactsInWaitList
    });
  };

  getCurrentContactsApi = async (id: any) => {
    console.log(id, "idForContact")
    this.getCurrentContactListId = await this.apiFrame({
      contentType: configJSON.contentType,
      method: configJSON.getApiMethod,
      endPoint: configJSON.getCurrentContactsEndPointForAutoFill + `/${id}`
    });
  };

  getAutoFillPerticularContactApi = async () => {
    this.getPerticularContactId = await this.apiFrame({
      contentType: configJSON.contentType,
      method: configJSON.getApiMethod,
      endPoint: configJSON.contactsInWaitListEndPoint + `/${this.state.selectedContactId}`
    });
  };

  // Helper method to ensure automation data structure exists
  ensureAutomationDataStructure = (data: any[]) => {
    if (!Array.isArray(data)) return data;

    return data.map((item: any) => {
      // Ensure attributes exist
      if (!item.attributes) {
        item.attributes = {};
      }

      // If automation data doesn't exist, create a default structure
      if (!item.attributes.automation) {
        item.attributes.automation = {
          name: item.attributes.name || item.name || 'Default Automation',
          id: item.attributes.id || item.id || Math.random().toString()
        };
      }

      return item;
    });
  }

  // Message Variables Processing Methods
  initializeMessageProcessor = () => {
    const context: MessageVariableContext = {
      contact: this.state.perticularContactDetail ? {
        id: this.state.perticularContactDetail.id || this.state.perticularContactDetail.attributes?.id,
        first_name: this.state.perticularContactDetail.attributes?.first_name || this.state.perticularContactDetail.first_name,
        last_name: this.state.perticularContactDetail.attributes?.last_name || this.state.perticularContactDetail.last_name,
        full_name: this.state.perticularContactDetail.attributes?.full_name || this.state.perticularContactDetail.full_name,
        phone_number: this.state.perticularContactDetail.attributes?.phone_number || this.state.perticularContactDetail.phone_number,
        email: this.state.perticularContactDetail.attributes?.email || this.state.perticularContactDetail.email
      } : undefined,
      business: {
        id: localStorage.getItem('businessId') || '',
        name: this.state.businessName || 'Business Name',
        contact_first_name: this.state.businessContactFirstName || 'Business Contact',
        contact_last_name: this.state.businessContactLastName || '',
        contact_full_name: `${this.state.businessContactFirstName || 'Business Contact'} ${this.state.businessContactLastName || ''}`,
        office_number: this.state.businessPhoneNumber || '',
        email: this.state.businessEmail || ''
      },
      system: {
        current_user_id: localStorage.getItem('userId') || '',
        current_business_id: localStorage.getItem('businessId') || '',
        timestamp: new Date().toISOString()
      }
    };

    this.setState({
      messageVariableContext: context,
      messageProcessor: new MessageVariableProcessor(DEFAULT_MESSAGE_VARIABLES, context)
    });
  }

  processMessageWithVariables = (message: string): string => {
    const { messageProcessor } = this.state;

    if (messageProcessor) {
      return messageProcessor.processMessage(message);
    }

    return message;
  }

  // Enhanced message processing for waitlist
  processWaitlistMessage = (template: string, contactName?: string, providerName?: string, businessName?: string): string => {
    let processedMessage = template;

    // Replace basic variables first
    if (contactName) {
      processedMessage = processedMessage.replace(/:contact_first_name:/g, contactName);
      processedMessage = processedMessage.replace(/:contact_full_name:/g, contactName);
    }

    if (providerName) {
      processedMessage = processedMessage.replace(/:business_contact_first_name:/g, providerName);
      processedMessage = processedMessage.replace(/:business_contact_full_name:/g, providerName);
    }

    if (businessName) {
      processedMessage = processedMessage.replace(/:business_name:/g, businessName);
    }

    // Process with message processor if available
    if (this.state.messageProcessor) {
      processedMessage = this.state.messageProcessor.processMessage(processedMessage);
    }

    return processedMessage;
  }

  handleFavorite = () => {
    this.setState(prevState => ({
      isLike: !prevState.isLike,
    }));
  };
}
// Customizable Area End
